<p-confirmdialog />
<h3 i18n="@@template-page-title">Vorlagen verwalten</h3>
<p
  class="text-muted"
  i18n="@@template-page-description"
  >
  Hier findest du alle verfügbaren Vorlagen. Jede Vorlage bildet einen vollständigen Anwendungsfall ab und kann direkt
  als Grundlage für neue Bots verwendet werden.
</p>

@if (bots.length > 0) {
  <div
    class="d-flex justify-content-end align-items-center mb-2"
    >
    <p-iconfield>
      <p-inputicon class="ri ri-search-line" />
      <input
        pInputText
        #filterInput
        (input)="dt.filterGlobal(filterInput.value, 'contains')"
        type="text"
        i18n-placeholder="@@search-placeholder"
        placeholder="Suchen..."
        />
    </p-iconfield>
  </div>
}

<p-table
  #dt
  sortField="updated"
  [sortOrder]="-1"
  [globalFilterFields]="['name', 'creatorName']"
  [value]="bots"
  [rowHover]="bots.length > 0"
  >
  <ng-template #header>
    @if (bots.length > 0) {
      <tr>
        <th style="width: 82px;"></th>
        <th
          [noWrap]="true"
          style="width: 100%; display: flex; align-items: center; gap: 20px;"
          >
          <span pSortableColumn="name">
            <ng-container i18n="@@name">Name</ng-container>
            <p-sorticon
              field="name"
              style="margin-left: 5px;"
              />
          </span>
          <span pSortableColumn="creatorName">
            <ng-container i18n="@@owner">Eigentümer</ng-container>
            <p-sorticon
              field="creatorName"
              style="margin-left: 5px;"
              />
          </span>
        </th>
        <th
          [noWrap]="true"
          style="width: 141px;"
          >
          <span pSortableColumn="updated">
            <ng-container i18n="@@last-change">Aktualisiert</ng-container>
            <p-sorticon
              field="updated"
              style="margin-left: 5px;"
              />
          </span>
        </th>
        <th
          [noWrap]="true"
          style="width: 120px;"
          >
          <span pSortableColumn="isTemplateDraft">
            <ng-container i18n="@@status">Status</ng-container>
            <p-sorticon
              field="isTemplateDraft"
              style="margin-left: 5px;"
              />
          </span>
        </th>
        <th style="width: 72px;"></th>
      </tr>
    }
  </ng-template>
  <ng-template
    #body
    let-bot
    >
    <tr>
      <td>
        <app-bot-icon [botConfig]="bot"></app-bot-icon>
      </td>
      <td [noWrap]="true">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <div class="d-flex flex-column gap-2">
              <a [routerLink]="['/','bot-admin', bot._id, botService.getBotDeeplink(bot)]">{{bot.name}}</a>
              <span>{{bot.creatorName}}</span>
            </div>
          </div>
        </div>
      </td>
      <td
        style="vertical-align: top;"
        [noWrap]="true"
        >
        <div>
          <span>
            @if (bot.updator) {
              <div>
                <a
                  class="href-muted"
                  [routerLink]="['/','bot-admin', bot._id, 'changelog']"
                  >
                  {{dayjs(bot.updated).fromNow()}}
                </a>
                <br>
                  <span>{{bot.updator}}</span>
                </div>
              }
            </span>
          </div>
        </td>
        <td
          style="vertical-align: top;"
          [noWrap]="true"
          >
          @if (bot.isTemplateDraft) {
            <p-tag
              i18n-value="@@template-draft"
              value="Entwurf"
              severity="warn"
              />
          }
          @if (!bot.isTemplateDraft) {
            <p-tag
              i18n-value="@@template-published"
              value="Veröffentlicht"
              severity="success"
              />
          }
        </td>
        <td style="vertical-align: top;">
          <p-popover
            [dismissable]="true"
            #popover
            appendTo="body"
            >
            <div class="flex flex-column">
              @for (item of contextMenu; track item) {
                <div
                  class="flex align-items-center gap-3 py-1 px-2 cursor-pointer popover-hover transition-colors transition-duration-150"
                  (click)="item.command(); popover.hide()"
                  >
                  <i
                    [class]="item.icon"
                    class="text-secondary me-3"
                  ></i>
                  <span class="text-color">{{ item.label }}</span>
                </div>
              }
            </div>
          </p-popover>
          <p-button
            #btn
            (click)="openMenu($event, popover, bot, btn)"
            rounded
            severity="secondary"
            icon="ri ri-more-2-fill"
            styleClass="button-icon"
            />
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="5"
          class="text-center p-5 text-muted"
          >
          @if (bots.length === 0) {
            <ng-container
              i18n="@@no-templates-yet"
              >
          Noch keine Vorlagen vorhanden.
        </ng-container>
          }
          @if (bots.length > 0) {
            <ng-container
              i18n="@@no-templates-found"
              >
          Keine Vorlagen gefunden. Passe deine Suche an.
        </ng-container>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
